import _ from 'lodash';
import { PatientFormTemplate } from 'requests/resources';

import { PatientFormQuestion, PatientFormTemplateItem } from '@lib/resources/types';
import { getRedirectConfig } from '@lib/services/patientFormsService';

const getNextItem = (items: PatientFormTemplateItem[], currentItem?: PatientFormTemplateItem, answer?: any) => {
  let nextItem: PatientFormTemplateItem | undefined;
  const redirectItem = _.defaultsDeep({}, answer, currentItem);
  const redirectConfig = getRedirectConfig(redirectItem);
  const itemsFlattened = _.reduce(
    items,
    (result: PatientFormTemplateItem[] | PatientFormQuestion[], item) =>
      _.compact(_.concat(result, item, _.get(item, 'properties.items', []))),
    [],
  );
  if (redirectConfig.redirectType === 'goTo') {
    nextItem = _.find(itemsFlattened, { id: redirectConfig.properties.goTo });
  } else if (redirectConfig.redirectType === 'none') {
    const index = _.findIndex(itemsFlattened, { id: _.get(currentItem, 'id') });
    nextItem = _.get(itemsFlattened, index + 1);
  }
  return nextItem;
};

export const getLumaBotFlowNextItem = (
  flowTemplate?: PatientFormTemplate,
  currentItem?: PatientFormTemplateItem,
  answer?: any,
): PatientFormTemplateItem | undefined => {
  if (!currentItem) {
    return _.get(flowTemplate, 'template.items[0]');
  }
  return getNextItem(_.get(flowTemplate, 'template.items'), currentItem, answer);
};
